import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7277badc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mypage py-3" }
const _hoisted_2 = { class: "section px-3 pt-4 mt-2" }
const _hoisted_3 = { class: "bg-white border border-outline-color px-3 mt-1 round-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "メール", -1))
const _hoisted_5 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "プッシュ通知", -1))
const _hoisted_7 = { class: "d-flex justify-content-end align-items-center" }

import { useRouter } from "vue-router";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter();
const toMypageSubscribeNewsletter = { name: "MypageSubscribeNewsletter" };
const toMypageReceivePushNotification = {
  name: "MypageReceivePushNotification"
};

function onClickBack() {
  router.back();
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      メール・プッシュ通知受信設定\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_RouterLink, {
            to: toMypageSubscribeNewsletter,
            class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(FeatherIcon, {
                  icon: "chevron-right",
                  size: "1x",
                  class: "text-gray-05 ml-2"
                })
              ])
            ], undefined, true),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_RouterLink, {
            to: toMypageReceivePushNotification,
            class: "d-flex justify-content-between align-items-center border-top border-outline-color py-3"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(FeatherIcon, {
                  icon: "chevron-right",
                  size: "1x",
                  class: "text-gray-05 ml-2"
                })
              ])
            ], undefined, true),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})